import type {AJAXResponseProductData, DisplayType, ProductType, SelectionType} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import type {SocialMediaResponse} from '@Panels/poster-publishing-options-panel/components/publishing-social-media-panel/publishing-social-media-panel.types';
import type {OrderDetailsForRedux} from '@Panels/poster-publishing-options-panel/components/publishing-embed-in-webpage-panel/publishing-embed-in-webpage-panel.types';
import type {SubFlowType} from '@Panels/poster-publishing-options-panel/components/publishing-digital-signage-list/components/digital-signage-compiled-sub-panel/digital-signage-compiled-sub-panel.types';
import {useAppSelector} from '@/hooks';

export const useSelectionType = (): SelectionType => {
    return useAppSelector((state) => {
        return state.publishingOptionsPanel.selectionType;
    });
};
export const useDisplayType = (): DisplayType => {
    return useAppSelector((state) => {
        return state.publishingOptionsPanel.displayType;
    }) as DisplayType;
};
export const useShowLoader = (): boolean => {
    return useAppSelector((state) => {
        return state.publishingOptionsPanel.showLoader;
    });
};
export const useFreebieProduct = (): AJAXResponseProductData | undefined => {
    return useAppSelector((state) => {
        return state.publishingOptionsPanel.freebieProductData;
    });
};

export const usePrintProduct = (): AJAXResponseProductData | undefined => {
    return useAppSelector((state) => {
        return state.publishingOptionsPanel.premiumProductDataForPrint;
    });
};

export const usePosterProduct = (): AJAXResponseProductData | undefined => {
    return useAppSelector((state) => {
        return state.publishingOptionsPanel.premiumProductDataForPoster;
    });
};

export const useOrderDetails = (): OrderDetailsForRedux => {
    return useAppSelector((state) => {
        return state.publishingOptionsPanel.orderDetails;
    });
};

export const useProductType = (): ProductType | undefined => {
    return useAppSelector((state) => {
        return state.publishingOptionsPanel.productType;
    });
};

export const useSocialMediaLinks = (): SocialMediaResponse => {
    return useAppSelector((state) => {
        return state.publishingOptionsPanel.socialMediaLinks;
    });
};

export const useSubFlowType = (): SubFlowType => {
    return useAppSelector((state) => {
        return state.publishingOptionsPanel.subFlowType;
    });
};

export const useErrorMessageForPublishing = (): string => {
    return useAppSelector((state) => {
        return state.publishingOptionsPanel.errorMessage;
    });
};

export const useShowError = (): boolean => {
    return useAppSelector((state) => {
        return state.publishingOptionsPanel.showError;
    });
};

export const useHashedId = (): string => {
    return useAppSelector((state) => {
        return state.publishingOptionsPanel.hashedId;
    });
};
